import { defineComponent as _defineComponent } from 'vue'
import { inject, onBeforeUnmount, ref, watch } from "vue";
import router from "@/router/index";
import { Form } from "vee-validate";
import { useUserStore } from "@/stores/userStore";
import { computed } from "@vue/reactivity";
import validatePhoneNum from "@/views/signup/validatePhoneNum";
import validateVerificationCode from "@/views/signup/validateVerificationCode";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import ButtonInput from "@/components/shared/inputs/ButtonInput.vue";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";


const __default__ = {
  name: "ChangePhoneNumber",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const userStore = useUserStore();
const currentPhoneNumber = userStore.userInfo!.phone;
const schema = computed(() => {
  return {
    newPhone: `required:휴대폰을|phone|newPhone:${currentPhoneNumber}`,
    verification: "required:인증번호를|",
  };
});

const {
  phoneNumber,
  verificationTitle,
  didSendVerificationCode,
  onChangePhoneNumber,
  sendPhoneVerificationCode,
} = validatePhoneNum();

const verificationInput = ref<typeof ButtonInput>();
const {
  verificationCode,
  isVerificationSuccess,
  isVerificationTimeOut,
  remainingTimeStr,
  verificationCodeErrorMessage,
  verificationCodeSuccessMessage,
  onChangeVerificationCode,
  verifyCode,
  startTimer,
  stopTimer,
} = validateVerificationCode(phoneNumber, didSendVerificationCode);

const onClickChangePhoneNumber = async (isCompletForm: boolean) => {
  if (!isCompletForm) {
    return;
  }
  const changePhoneNumterResult = await userStore.changePhoneNumber(
    phoneNumber.value,
    verificationCode.value
  );
  if (!changePhoneNumterResult.isSuccess) {
    showErrorModal(
      "휴대폰 번호 변경 오류",
      changePhoneNumterResult.errorMessage,
      changePhoneNumterResult.resultCode,
      changePhoneNumterResult.errorTime
    );
    return;
  }
  userStore.updatePhoneNumber(phoneNumber.value);
  showToastMessage("휴대폰 번호가 변경되었습니다", 3000, 350);
  router.back();
};

watch(didSendVerificationCode, (didSendVerificationCode) => {
  if (didSendVerificationCode) {
    startTimer();
  } else {
    stopTimer();
  }
});

onBeforeUnmount(() => {
  stopTimer();
});

const __returned__ = { showErrorModal, showToastMessage, userStore, currentPhoneNumber, schema, phoneNumber, verificationTitle, didSendVerificationCode, onChangePhoneNumber, sendPhoneVerificationCode, verificationInput, verificationCode, isVerificationSuccess, isVerificationTimeOut, remainingTimeStr, verificationCodeErrorMessage, verificationCodeSuccessMessage, onChangeVerificationCode, verifyCode, startTimer, stopTimer, onClickChangePhoneNumber, get Form() { return Form }, Page, NavigationBar, ButtonInput, BaseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})